import { TableColumn } from '@app/shared/models/generic-table.interface';
import { ViewColumnPreferences } from '@app/shared/models/view-config.interface';

/**
 * Columns of the active and archive eCMR tables offered by Show/Hide Columns.
 * The `id` column holds the row icons and is always shown, so it is not listed.
 */
export const ECMR_COLUMNS: TableColumn[] = [
    { key: 'referenceId', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.REF-ID' },
    { key: 'from', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.FROM' },
    { key: 'to', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.TO' },
    {
        key: 'transportType',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.TRANSPORT-TYPE',
    },
    { key: 'lastEditor', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDITOR' },
    { key: 'status', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.STATUS' },
    {
        key: 'lastEditDate',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.LAST-EDIT-DATE',
    },
    {
        key: 'creationDate',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.CREATION-DATE',
    },
    {
        key: 'licensePlate',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.LICENSE-PLATE',
    },
    { key: 'carrierName', header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-NAME' },
    {
        key: 'carrierPostCode',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.CARRIER-POST-CODE',
    },
    {
        key: 'consigneePostCode',
        header: 'ECMR.CONSIGNOR.ACTIVE-ECMR.CONSIGNEE-POST-CODE',
    },
];

export const ECMR_DEFAULT_HIDDEN = [
    'licensePlate',
    'carrierName',
    'carrierPostCode',
    'consigneePostCode',
];

/** Columns of the eCMR template table offered by Show/Hide Columns. */
export const ECMR_TEMPLATE_COLUMNS: TableColumn[] = [
    { key: 'number', header: 'ECMR.template_overview.table_header.number' },
    { key: 'name', header: 'ECMR.template_overview.table_header.name' },
    { key: 'refId', header: 'ECMR.overview.table_header.ref_id' },
    { key: 'from', header: 'ECMR.overview.table_header.from' },
    { key: 'to', header: 'ECMR.overview.table_header.to' },
];

/**
 * Show/Hide Columns setup for an eCMR sub-view ('overview', 'templates' or
 * 'archive'). Each sub-view keeps its own visibility setting.
 */
export function ecmrColumnPreferences(subView: string): ViewColumnPreferences {
    if (subView === 'templates') {
        return {
            viewKey: 'ecmr-templates',
            columns: ECMR_TEMPLATE_COLUMNS,
        };
    }
    return {
        viewKey: `ecmr-${subView}`,
        columns: ECMR_COLUMNS,
        defaultHidden: ECMR_DEFAULT_HIDDEN,
    };
}
